import { Promises } from "../promise/Promises.js";
var ImageUtils;
((ImageUtils2) => {
  function loadImageBitMap(src, callback) {
    let targetCallback;
    let catchCallback;
    let promise = void 0;
    if (callback) {
      targetCallback = callback.onload;
      catchCallback = callback.onerror;
    } else {
      const r = Promises.withResolvers();
      promise = r.promise;
      targetCallback = r.resolve;
      catchCallback = r.reject;
    }
    fetch(src, {
      mode: "cors",
      // CORS 요청 (기본값)
      credentials: "omit"
      // "anonymous"와 유사: 인증 정보(쿠키, HTTP 인증) 포함하지 않음
    }).then((response) => {
      return response.blob();
    }).then((it) => {
      return createImageBitmap(it);
    }).then((it) => {
      targetCallback(it);
    }).catch((it) => {
      catchCallback(it);
    });
    return promise;
  }
  ImageUtils2.loadImageBitMap = loadImageBitMap;
})(ImageUtils || (ImageUtils = {}));
export {
  ImageUtils
};
//# sourceMappingURL=ImageUtils.js.map
